import { useFlags } from 'launchdarkly-react-client-sdk';
import { FLAGS } from 'legacy/common/constants/launchdarkly';
import { useGetOffers } from 'legacy/events/hooks';
import { OffersStep } from 'legacy/events/offers.types';
import React, { useEffect } from 'react';
import SettingsOption from '../SettingsOption';

interface OffersSettingsProps {
  navigateToOffers: () => void;
  eventId: string;
  setOffersStep: (step: OffersStep) => void;
}

const OffersSettings: React.FC<OffersSettingsProps> = ({
  navigateToOffers,
  eventId,
  setOffersStep
}) => {
  const flags = useFlags();
  const { data } = useGetOffers(eventId, { enabled: !!eventId });

  useEffect(() => {
    if (data?.offers?.length) {
      setOffersStep(OffersStep.OFFERS_LIST);
    } else {
      setOffersStep(OffersStep.CREATE_OFFER);
    }
  }, [data]);

  if (flags[FLAGS.ENABLE_PROMOTER_OFFERS]) {
    return (
      <SettingsOption
        icon={<img src="/img/events/create/offer.svg" height={16} width={16} />}
        title="Promoter Offers"
        actionLabel="Add offer"
        onClick={navigateToOffers}
        tooltipMessage="An offer rewards promoters for each ticket sale made through their unique link."
        value={data?.offers?.length ? `${data?.offers?.length} total` : ''}
      />
    );
  }
  return null;
};

export default OffersSettings;
